import { render, staticRenderFns } from "./InvoiceProjectModal.vue?vue&type=template&id=b544f6e6&scoped=true&"
import script from "./InvoiceProjectModal.vue?vue&type=script&lang=js&"
export * from "./InvoiceProjectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b544f6e6",
  null
  
)

export default component.exports